// import {RawAxiosRequestConfig} from 'axios';
import {cleanFields} from '../../../utilities/helper/cleanFields';
import request from '../../axios';

const PatchToolAdvertisement = async (
  payload: IToolAdvertisementPayload,
  guid?: string,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    description: payload?.description || null,
    type: payload?.type?.value,
    ad_price: payload.price_on_call ? null : payload.ad_price,
    price_on_call: payload?.price_on_call || false,
    has_discount: payload?.has_discount ? true : false,
    producing_country: payload?.producing_country?.guid || null,
    produce_year:
      payload?.produce_year && payload?.produce_year?.guid !== 'last'
        ? payload?.produce_year?.title
        : null,
    profile_type: 'supplier',
    attributes: payload.attributes ? payload.attributes : null,
    only_massage_buyer: payload.only_massage_buyer || false,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    filter: 'advertisement',
    discount_amount: payload?.discount_amount || null,
    images_id:
      payload?.images
        ?.map(item => item)
        .join(',')
        .toString() || null,
    main_image_id: payload?.main_image || null,
    sub_brand_main_image: payload?.sub_brand_main_image,
    ...(payload?.sub_brand && {sub_brand: payload?.sub_brand}),
    ...(payload?.sub_brand_images && {
      sub_brand_images: payload?.sub_brand_images,
    }),
    quantity_pack: payload?.quantity_pack || null,
    quantity_pack_unit: payload?.quantity_pack_unit?.value || null,
    available_quantity: payload.available_quantity || null,
    min_sell_quantity: payload?.min_sell_quantity || null,
    application_method: payload?.application_method || null,
    combinations: payload?.combinations || null,
  };

  // ✅ specify which fields to check/remove if null
  const cleanedPayload = cleanFields(newPayload, ['attributes']);

  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...cleanedPayload,
  });

  return response.data;
};

export default PatchToolAdvertisement;
